import { create } from 'zustand';
import { getEventTypes, getListErrors } from '../../../api/api';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ErrorIcon from '@mui/icons-material/Error';

const levels = [
  { name: 'Инфо', value: 0, icon: <CheckCircleIcon className="text-green-500" /> },
  { name: 'Предупреждение', value: 1, icon: <WarningIcon className="text-yellow-500" /> },
  { name: 'Ошибка', value: 2, icon: <ErrorOutlineIcon className="text-orange-500" /> },
  { name: 'Фатальная ошибка', value: 3, icon: <ErrorIcon className="text-red-700" /> },
];
const dictionaryCategory = { device: 'Устройства', integration: 'Интеграции', user: 'Пользователи' };

export const useEventTypesStore = create((set) => ({
  levels: levels,
  categories: [],
  types: [],
  messagesError: [],

  fetchEventTypes: async () => {
    await getListErrors((data) =>
      set({
        messagesError: data.map((item) => ({
          label: item,
          value: item,
        })),
      })
    );
    await getEventTypes(
      (data) => {
        const uniqueCategories = Array.from(new Set(data?.types.map((item) => item.Category)));
        const categories = uniqueCategories?.map((item) => {
          return { name: dictionaryCategory[item] ?? item, value: item };
        });
        const types = data?.types
          .sort((a, b) => a.Name.localeCompare(b.Name))
          .map((item) => {
            return { name: item.Name, value: item.Code };
          });
        set({ categories, types });
      },
      (err) => {
        set({ error: err.error || 'Ошибка при загрузке данных', isLoading: false });
      }
    );
  },
}));
